 import * as actionTypes from "../action-types"

 export const getAskAddQuestions= payload=>({
    type: actionTypes.GET_ASK_QUESTION,
    payload
 })
 export const setAskQuestions = payload=>({
    type: actionTypes.SET_ASK_QUESTION,
    payload
 })
 export const  addAskQuestions = payload =>({
    type: actionTypes.ADD_ASK_QUESTIONS,
    payload
 })
 export const  deleteAskQuestions = payload =>({
   type: actionTypes.DELETE_ASK_QUESTION,
   payload
})
export const  updateAskQuestions = payload =>({
   type: actionTypes.UPDATE_ASK_QUESTION,
   payload
})

export const  addReligionSpirituality = payload =>({
   type: actionTypes.ADD_RELIGION_SPRITUALITY,
   payload
})
export const getAllReligionSpirituality= payload=>({
   type: actionTypes.GET_ALL_RELIGION_SPRITUALITY,
   payload
})
export const  deleteReligionSpirituality = payload =>({
   type: actionTypes.DELETE_RELIGION_SPRITUALITY,
   payload
})

export const  updateReligionSpirituality = payload =>({
   type: actionTypes.UPDATE_RELIGION_SPRITUALITY,
   payload
})


export const  addAstroMagazine = payload =>({
   type: actionTypes.ADD_ASTRO_MAGAZINE,
   payload
})
export const getAstroMagazine= payload=>({
   type: actionTypes.GET_ALL_ASTRO_MAGAZINE,
   payload
})
export const setAstroMagazine = payload=>({
   type: actionTypes.SET_ALL_ASTRO_MAGAZINE,
   payload
})
export const deleteAstroMagazine = payload=>({
   type: actionTypes.DELETE_ASTRO_MAGAZINE,
   payload
})
export const updateAstroMagazine = payload=>({
   type: actionTypes.UPDATE_ASTRO_MAGAZINE,
   payload
})


export const addAnnouncement = payload=>({
   type: actionTypes.ADD_ANNOUNCEMENT,
   payload
})
export const getAllAnouncement = payload=>({
   type: actionTypes.GET_ALL_ANNOUNCEMENT,
   payload
})
export const setAllAnouncement = payload=>({
   type: actionTypes.SET_ALL_ANNOUNCEMENT,
   payload
})
export const deleteAnnouncement = payload=>({
   type: actionTypes.DELETE_ANNOUNCEMENT,
   payload
})
export const updateAnnouncement = payload=>({
   type: actionTypes.UPDATE_ANNOUNCEMENT,
   payload
})


export const addBirhatHoroscope = payload=>({
   type: actionTypes.ADD_BIRHAT_HOROSCOPE,
   payload
})
export const getAllBirhatHoroscope = payload=>({
   type: actionTypes.GET_ALL_BIRHAT_HOROSCOPE,
   payload
})
export const setAllBirhatHoroscope = payload=>({
   type: actionTypes.SET_ALL_BIRHAT_HOROSCOPE,
   payload
})
export const deleteBirhatHoroscope = payload=>({
   type: actionTypes.DELETE_BIRHAT_HOROSCOPE ,
   payload
})
export const updateBirhatHoroscope = payload=>({
   type: actionTypes.UPDATE_BIRHAT_HOROSCOPE ,
   payload
})


export const addAuspiciousTime = payload=>({
   type: actionTypes.ADD_AUSPICIOUS_TIME,
   payload
})
export const getAllAuspiciousTime = payload=>({
   type: actionTypes.GET_ALL_AUSPICIOUS_TIME,
   payload
})
export const setAllAuspiciousTime = payload=>({
   type: actionTypes.SET_ALL_AUSPICIOUS_TIME,
   payload
})
export const deleteAuspiciousTime = payload=>({
   type: actionTypes.DELETE_ALL_AUSPICIOUS_TIME ,
   payload
})
export const updateAuspiciousTime = payload=>({
   type: actionTypes.UPDATE_AUSPICIOUS_TIME ,
   payload
})


export const addDailyPanchang = payload=>({
   type: actionTypes.ADD_DAILY_PANCHANG ,
   payload
})
export const getAllDailyPanchang = payload=>({
   type: actionTypes.GET_ALL_DAILY_PANCHANG,
   payload
})
export const setAllDailyPanchang = payload=>({
   type: actionTypes.SET_ALL_DAILY_PANCHANG,
   payload
})
export const deleteDailyPanchang = payload=>({
   type: actionTypes.DELETE_DAILY_PANCHANG ,
   payload
})
export const updateDailyPanchang = payload=>({
   type: actionTypes.UPDATE_DAILY_PANCHANG ,
   payload
})


export const addYellowBook = payload=>({
   type: actionTypes.ADD_YELLOW_BOOK ,
   payload
})
export const getAllYellowBook = payload=>({
   type: actionTypes.GET_ALL_YELLOW_BOOK,
   payload
})
export const setAllYellowBook = payload=>({
   type: actionTypes.SET_ALL_YELLOW_BOOK,
   payload
})
export const deleteYellowBook = payload=>({
   type: actionTypes.DELETE_YELLOW_BOOK ,
   payload
})
export const updateYellowBook = payload=>({
   type: actionTypes.UPDATE_YELLOW_BOOK ,
   payload
})


// export const addremedies = payload=>({
//    type: actionTypes.ADD_REMEDIES ,
//    payload
// })
// export const getRemediesNew = payload=>({
//    type: actionTypes.GET_ALL_REMEDIES_NEW,
//    payload
// })
// export const setRemediesNew = payload=>({
//    type: actionTypes.SET_ALL_REMEDIES_NEW,
//    payload
// })
// export const deleteRemediesNew = payload=>({
//    type: actionTypes.DELETE_REMEDIES_NEW,
//    payload
// })
// export const updateRemediesNew = payload=>({
//    type: actionTypes.UPDATE_REMEDIES_NEW ,
//    payload
// })


export const createAppTutorials = payload=>({
   type: actionTypes.CREATE_APP_TUTORIALS ,
   payload
})
export const getAppTutorials= payload=>({
   type: actionTypes.GET_APP_TUTORIALS,
   payload
})
export const setAppTutorials = payload=>({
   type: actionTypes.SET_APP_TUTORIALS,
   payload
})
export const deleteAppTutorials = payload=>({
   type: actionTypes.DELETE_APP_TUTORIALS,
   payload
})

